import { useEffect, useRef, useState } from 'react'
import { Navigate, useSearchParams } from 'react-router-dom'
import { handleLoginCallback } from '../services/auth'
import Loader from '../components/Loader'

const Callback = () => {
	const [searchParams] = useSearchParams()
	const [status, setStatus] = useState('loading')
	const [error, setError] = useState('')
	const exchangeStarted = useRef(false)

	useEffect(() => {
		// O authorization code so pode ser trocado uma vez. Em dev, StrictMode roda
		// o efeito duas vezes de proposito - sem essa guarda, a segunda chamada
		// reusa o mesmo code (ja consumido) e volta 400 do authserver.
		if (exchangeStarted.current) {
			return
		}
		exchangeStarted.current = true

		handleLoginCallback(searchParams)
			.then(() => setStatus('done'))
			.catch((err) => {
				setError(err.message)
				setStatus('error')
			})
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	if (status === 'done') {
		return <Navigate to="/" replace />
	}

	if (status === 'error') {
		return (
			<div className="min-h-screen flex flex-col items-center justify-center gap-4 px-6 bg-gradient-to-br from-gray-50 to-gray-100">
				<p className="text-sm text-red-700">{error}</p>
				<a
					href="/login"
					className="inline-flex items-center rounded-xl bg-primary-600 px-6 py-3 text-sm font-semibold text-white hover:bg-primary-700"
				>
					Voltar para o login
				</a>
			</div>
		)
	}

	return (
		<div className="min-h-screen flex flex-col items-center justify-center gap-3 bg-gradient-to-br from-gray-50 to-gray-100">
			<Loader size="lg" />
			<p className="text-sm text-gray-500">Concluindo login...</p>
		</div>
	)
}

export default Callback
